import React from 'react';
import { useCompanyBranding } from '../../hooks';
import { Banner as BannerModel } from '../../models';
import HomeButtonBanner from './homeButtons/HomeButtonBanner';
import HomeImage from './homeBanners/HomeImage';
import HomeParagraphsBanner from './homeParagraphs/HomeParagraphsBanner';
import imageHand from '../../public/images/hand.png';

export default function Banner() {
  const [companyBrandingInfo, setCompanyBrandingInfo] =
    React.useState<BannerModel>({
      title: '',
      text: [],
      image: '',
      buttons: [],
      seccion: '',
    });
  const [companyBranding] = useCompanyBranding();

  React.useEffect(() => {
    if (!companyBranding) return;
    const bannerItem = companyBranding?.banners?.find(
      (banner: BannerModel) => banner.seccion === 'principal'
    );
    if (bannerItem) {
      setCompanyBrandingInfo(bannerItem);
    }
  }, [companyBranding]);

  return (
    <div className="w-full h-full flex flex-row bg-center bg-cover relative">
      <div className="w-full h-full bg-fixed flex flex-row bg-center bg-cover absolute z-10">
        {companyBrandingInfo?.image ? (
          <HomeImage bannerImage={companyBrandingInfo?.image} />
        ) : null}
      </div>
      <div className="w-full h-full flex flex-row bg-center bg-cover pt-10 z-20 justify-center items-center my-20">
        <div className="flex flex-col gap-5 xl:pl-20 lg:pl-20 lg:w-3/5 w-full px-10">
          <HomeParagraphsBanner bannerInfo={companyBrandingInfo} />
          <HomeButtonBanner buttonsInfo={companyBrandingInfo?.buttons} />
        </div>
        <div className=" lg:flex hidden mx-auto relative w-[40%]">
          {companyBranding?.logo?.image ? (
            <HomeImage
              bannerImage={companyBranding?.logo?.image}
              className="absolute scale-150 top-[50%] right-[50%] transform translate-x-1/2 -translate-y-1/2"
              altText="Company Logo"
            />
          ) : (
            <img
              src={imageHand.src}
              alt="Hand"
              className="absolute scale-75 top-[50%] right-[50%] transform translate-x-1/2 -translate-y-1/2"
            />
          )}
        </div>
      </div>
    </div>
  );
}
